module.exports = __webpack_public_path__ + "static/media/lunch-box.118b7ef9.png";